
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tradition",
      function () {
        return require("private-next-pages/tradition.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tradition"])
      });
    }
  